import { Component, OnInit, AfterContentInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import * as moment from 'moment-timezone';
import { StripeService } from 'ngx-stripe';
import { StripeElements, StripeElement } from '@stripe/stripe-js';

@Component({
  selector: 'session-payment',
  templateUrl: './sessionpayment.component.html'
})
export class SessionPaymentComponent extends BaseComponent implements OnInit {

  @ViewChild('card-element') cardElementRef: ElementRef;
  sessionDetails: SessionBookingVM | null = null;

  elements: StripeElements;
  card: StripeElement;
  isCardDetailsValid = false;
  isTermsAccepted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accService: AccountService,
    private stripeService: StripeService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.sessionDetails = this.accService.newSessionBooking;
    if (this.sessionDetails == null) {
      this.router.navigateByUrl('/');
      return;
    }
  }

  cancel() {
    this.accService.newSessionBooking = null;
    this.router.navigateByUrl('/profile/' + (this.sessionDetails as SessionBookingVM).mbNumber);
  }

  bookingResponse(response: Response) {
    this.emitDisplayLoadingDialog(false);
    switch (response.status) {
      case 200:
        var session: SessionBookingVM = response.body as SessionBookingVM;
        if (session != null) {
          this.accService.confirmedSessionBooking = session;
          this.router.navigateByUrl('/session-confirmed');
        }
        break;
      case 404:
        this.router.navigateByUrl('/session-taken');
        break;
      case 402:
        if (this.me.isBusinessUser) {
          this.showDialog('You\'re organisation has used up it\'s Pre-paid sessions, please contact your administrator', true);
        } else {
          this.showDialog('Payment Declined', true);
        }
        break;
      case 400:
        this.showDialog('An unknown error has occured, please try again', true);
        break;
    }
  }

}
